/* eslint-disable no-multi-spaces */
import round from 'lodash/round'
import { parseNumber } from '@utils/numberConversions'

import { INTEREST_RATE_CONTROL } from './AssetFields'
import { RETIREMENT_FUNDING_ASSETS, inferInterestRateFromAssetAllocation } from '../../utils/assetServices'

export const handleInterestRateControlChanges = (formProps, state) => {
  const { formAssetType, assumptions, riskProfile } = state
  const { inflation, assetAllocationGrowthRates } = assumptions

  return async (values) => {
    const { setFieldValue, validateForm, setFieldTouched } = formProps
    const errors = await validateForm()

    if (values.interestRateControl === INTEREST_RATE_CONTROL.BASED_ON_RISK_PROFILE) {
      setFieldValue('interestRate', interestRateBasedOnRiskProfile(riskProfile, inflation, formAssetType))
      setFieldTouched('interestRate')
    } else if (values.interestRateControl === INTEREST_RATE_CONTROL.BASED_ON_ASSET_ALLOCATION && validAssetAllocations(errors)) {
      setFieldValue('interestRate', inferInterestRateFromAssetAllocation(values, assetAllocationGrowthRates, formAssetType, inflation))
      setFieldTouched('interestRate')
    }
  }
}

const interestRateBasedOnRiskProfile = (riskProfile, inflation, formAssetType) => {
  const riskProfileReturnRate = overallReturnRate(riskProfile, inflation)

  if (RETIREMENT_FUNDING_ASSETS.includes(formAssetType)) {
    return round(Math.min(riskProfileReturnRate, (inflation * 100) + 4), 2)
  } else {
    return round(riskProfileReturnRate, 2)
  }
}

const overallReturnRate = (riskProfile, inflation) =>
  parseNumber(riskProfile?.rating) + (parseNumber(inflation) * 100)

const validAssetAllocations = (errors) => !errors.allocationTotal
